/* eslint-disable @typescript-eslint/no-magic-numbers */
import type { ExportFeatureConfig, TransactionsFeatureConfig } from '@shared/transactions-config';

export const transactions: TransactionsFeatureConfig = {
    detailFields: [],
    useFormattedExchangeRate: false,
    showPartnerAddress: false,
    showReceiverAddress: false,
    showSenderAddress: false,
    showOriginator: false,
    showOriginatorDirectlyFromApi: false,
    showBankFee: true,
    showTransactionFee: false,
    showReceiverName: false,
    showSenderName: false,
    showIbanForInstantPayment: false,
    showSymbols: true,
    showPurposeCode: false,
    yearsSinceEpoch: 7,
    singleTransactionPrint: true,
    specialSenderReferenceLabel: false,
    specialReferenceLabelsForForeign: false,
    showExchangeDate: false,
    includePfmInSearch: true,
    showSepaRecurrence: false,
    upcomingTimeModes: [3, 7, 14, 30, 60, 90],
    defaultUpcomingOrderDays: 14,
    stripLeadingZeros: false,
    showAccountPrefix: false,
    showBankCodeLabel: true,
    attachmentDownloadByForm: false,
    list: {
        columns: {
            valuationDate: false,
            inputDate: false,
        },
    },
    printing: {
        columns: {
            ownerAccountOrCard: false,
            variableSymbol: false,
            statementOrInvoiceNumber: false,
            valuationDate: false,
            inputDate: false,
        },
    },
    writtenItems: {
        addBookingType: false,
        addAllTypes: false,
    },
    showInstructionName: false,
    claims: {
        oidcReady: false,
        preferTokenExchange: false,
        handover: {
            paramNames: [],
            paramValues: {},
        },
    },
    claimsFee: {
        oidcReady: false,
        preferTokenExchange: false,
        handover: {
            paramNames: [],
            paramValues: {},
        },
    },
    retrievals: {
        oidcReady: false,
        preferTokenExchange: false,
        handover: {
            paramNames: [],
            paramValues: {},
        },
    },
    postalConfirmation: {
        handover: {
            targetClientId: '',
        },
    },
    showPosPaymentSenderAccountFields: false,
    showPosPaymentReceiverAccountFields: false,
    showSenderFieldsForAllPayments: false,
    showReceiverFieldsForAllPayments: false,
    showBookingTypeForTransactionTypes: [],
    showExecutionTimeForTransactionTypes: [],
    showExecutionTimeForSepaSchemes: [],
    searchForAmountInFulltextMode: true,
    disableDecimalSearchForCurrencies: ['HUF'],
    exportCenter: {
        withCreatedDateParams: false,
    },
};

export const exportFeatures: ExportFeatureConfig = {
    lastExport: '',
    lastExportOption: false,
    fields: [] as { name: string; preselected: boolean; selectable: boolean }[],
    pdf: false,
    ofx: false,
    sortParams: [],
    yearsSinceEpoch: 7,
};
